import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
// import Link from '@material-ui/core/Link';
import { userActions } from '../actions';
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme) => ({
  appBar: {
    top: 'auto',
    bottom: 0,
  },
  fabButton: {
    position: 'absolute',
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: '0 auto',
  },
  footer: {
    minHeight: '30px'
  },
  cright: {
    color: '#d5d5d5'
  }
}));

const TheFooter = () => {
  const { t } = useTranslation('footer');
  const { t:homemainT } = useTranslation('homemain');
  const classes = useStyles();
  const thisRef = useRef(null);
  const categoryRef = useRef(null);
  const dispatch = useDispatch()
  const user = useSelector(state => state.user);

  const HandleServiceClick = () => {
    //dispatch({ type: constants.GOTO_SERVICE_DETAIL });
    thisRef.current.click();
  }
  const HandleCategoryClick = () => {
    categoryRef.current.click();
  }

  return (
    <React.Fragment>
      <footer>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-5 order-lg-3">
                            <div className="footer-logo"> <Link to={'/dashboard'}><img src="src/images/logo.png" /></Link></div>
                        </div>
                        <div class="col-lg-2 order-lg-2">
                            <div class="footer-whatsupp">
                                <a href="https://api.whatsapp.com/send?phone=9651881880" target="_blank"> <h5> <i class="fab fa-whatsapp"></i> 1881880 </h5> </a>
                            </div>
                        </div>
                        <div class="col-lg-5 order-lg-1">
                            <ul>
                                <li> <a href="http://live.spediaapp.com/Spedia_PrivacyPolicy.html" target="_blank">{homemainT('privacy policy')} </a></li>
                                <li> <a href="https://live.spediaapp.com/TaC_LiveClass.html" target="_blank"> {homemainT('Terms and Conditions')} </a></li>
                                {/* <li> <a href="javscript:void(0)">  {homemainT('common questions')} </a></li> */}
                            </ul>
                        </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="footer-download">
                                    <a href="https://play.google.com/store/apps/details?id=com.kw.spedia&hl=en_IN" target="_blank"><img src="src/images/android-app.png"></img></a>
                                    <a href="https://apps.apple.com/us/app/spedia/id1524345281" target="_blank"><img src="src/images/ios-app.png"></img></a>
                                    <a href="https://appgallery.huawei.com/#/app/C105954987" target="_blank"><img src="src/images/huwai-app.png"></img></a>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="footer-icons">
                                    <ul>
                                        <a href="https://www.instagram.com/spediaapp/" target="_blank"><i class="fab fa-instagram box-shadow2"></i></a>
                                        <a href="https://www.youtube.com/channel/UCgkBDHIhE1ECUJ3l09JbPBg" target="_blank"><i class="fab fa-youtube box-shadow2"></i></a>
                                        <a href="https://twitter.com/spediaapp/" target="_blank"><i class="fab fa-x box-shadow2"></i></a>
                                        <a href="https://www.facebook.com/Spediaapp/" target="_blank"><i class="fab fa-facebook-f box-shadow2"></i></a>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 footer-copyright">
                                <p> {homemainT('CopyrightText')}</p>
                            </div>
                    </div>
                </div>
            </footer>  

     

    </React.Fragment>
  )
}

export default React.memo(TheFooter)
